import { httpStatusList } from "@/constants/errors-http/HTTPHandler";
import GeneratingUnitFeaturesController from "@/controllers/common/GeneratingUnitFeaturesController";

/**
 * Obtém as features da unidade geradora de acordo com seu id.
 * @param {Number} monitoringElementId Id da unidade geradora.
 */
const GetGeneratingUnitFeatures = async(monitoringElementId) =>
{
	const resp = await GeneratingUnitFeaturesController.GetGeneratingUnitFeatures(monitoringElementId);

	if (resp.status === httpStatusList.noContent) return [];

	return resp.data;
};

export default { GetGeneratingUnitFeatures };